import ApiClient from '../../loopback/apiClient';
import {
  SET_GROUND_TRUTHS,
  SET_SELECTED_GROUND_TRUTH,
  UPDATE_GROUND_TRUTH,
  AppThunk,
  GroundTruth,
  GroundTruthActionTypes,
  ADD_GROUND_TRUTH,
  DELETE_GROUND_TRUTH,
} from '../types';

export const setSelectedGroundTruth = (gtId?: number): GroundTruthActionTypes => ({
  type: SET_SELECTED_GROUND_TRUTH,
  payload: gtId,
});

export const setGroundTruthsRedux = (groundTruths: GroundTruth[]): GroundTruthActionTypes => ({
  type: SET_GROUND_TRUTHS,
  payload: groundTruths,
});

export const updateGroundTruthRedux = (groundTruth: GroundTruth): GroundTruthActionTypes => ({
  type: UPDATE_GROUND_TRUTH,
  payload: groundTruth,
});

export const addGroundTruthRedux = (groundTruths: GroundTruth[]): GroundTruthActionTypes => ({
  type: ADD_GROUND_TRUTH,
  payload: groundTruths,
});

export const deleteGroundTruthRedux = (groundTruthId: number): GroundTruthActionTypes => ({
  type: DELETE_GROUND_TRUTH,
  payload: groundTruthId,
});

export const fetchGroundTruths = (surveyId: number): AppThunk => async (dispatch, getState) => {
  const state = getState();
  const filter = {
    where: {
      surveyId,
    },
  };
  const groundTruths = await ApiClient.getGroundTruths(filter);
  dispatch(setGroundTruthsRedux(groundTruths));
  if (!state.groundTruth.selectedGroundTruth && groundTruths.length) {
    // set default groundtruth
    dispatch(setSelectedGroundTruth(groundTruths[0].id));
  }
};

export const createGroundTruth = (groundTruth: Omit<GroundTruth, 'id'>): AppThunk => async (dispatch) => {
  const createdGT = await ApiClient.createGroundTruth(groundTruth);
  dispatch(addGroundTruthRedux([createdGT]));
  dispatch(setSelectedGroundTruth(createdGT.id));
};

export const updateGroundTruth = (
  gtId: number, gtData: Omit<GroundTruth, 'id'>,
): AppThunk => async (dispatch) => {
  const updatedGT = await ApiClient.updateGroundTruth(gtId, gtData);
  dispatch(updateGroundTruthRedux(updatedGT));
};

export const deleteGroundTruth = (id: number): AppThunk => async (dispatch) => {
  await ApiClient.deleteGroundTruth(id);
  dispatch(deleteGroundTruthRedux(id));
};
